import { render, staticRenderFns } from "./commentDetailDrawer.vue?vue&type=template&id=af432b2a&scoped=true"
import script from "./commentDetailDrawer.vue?vue&type=script&lang=js"
export * from "./commentDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./commentDetailDrawer.vue?vue&type=style&index=0&id=af432b2a&prod&lang=scss&scoped=true"
import style1 from "./commentDetailDrawer.vue?vue&type=style&index=1&id=af432b2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af432b2a",
  null
  
)

export default component.exports